import { QuestionsAnswersStatus } from '../../../constants/questions'
import { ecbrRequest } from '../../request/ecbrRequest'
import { getUnpaginatedAll } from '../../../helpers/getUnpaginatedAll'
import { objectToQueryString } from '../../../utils/objectToQueryString'

export const questionsAnswers = {
  getAll: async (params) =>
    ecbrRequest.get('/admin/questions-answers', { params }),
  getPendingApproval: async (params) =>
    ecbrRequest.get(
      `/admin/questions-answers${objectToQueryString({
        ...params,
        status: QuestionsAnswersStatus.PENDING_APPROVAL
      })}`
    ),
  getAllPendingApproval: async (params = {}) => {
    return {
      data: await getUnpaginatedAll(
        (pagination) =>
          ecbrRequest.get(`/admin/questions-answers`, {
            params: {
              ...params,
              ...pagination,
              status: QuestionsAnswersStatus.PENDING_APPROVAL
            }
          }),
        params.page,
        params.take
      )
    }
  },
  getApproved: async (params) =>
    ecbrRequest.get('/admin/questions-answers', {
      params: { ...params, status: QuestionsAnswersStatus.APPROVED }
    }),
  getReproved: async (params) =>
    ecbrRequest.get('/admin/questions-answers', {
      params: { ...params, status: QuestionsAnswersStatus.REPROVED }
    }),
  getAllByInvoiceId: async (invoiceId, params) =>
    ecbrRequest.get(`/admin/questions-answers`, {
      params: { ...params, invoiceId }
    }),
  getByQuestionType: async (questionType, params) =>
    ecbrRequest.get(`/admin/questions-answers`, {
      params: { ...params, questionType }
    }),
  updateStatus: async (id, status) =>
    ecbrRequest.put(`/admin/questions-answers/${id}/status`, { status }),
  answerQuestion: async (data) =>
    ecbrRequest.post(`/company/questions-answers`, data),
  getUserCertificatePillarAnswers: async (certificateId, params = {}) =>
    ecbrRequest.get(`/company/questions-answers`, {
      params: { ...params, certificateId }
    }),
  getAllUserCertificatePillarAnswers: async (certificateId, params = {}) => {
    return {
      data: await getUnpaginatedAll(
        (pagination) =>
          ecbrRequest.get(`/company/questions-answers`, {
            params: { ...params, ...pagination, certificateId }
          }),
        params.page,
        params.take
      )
    }
  }
}
